/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type ChatMessageType = typeof ChatMessageType[keyof typeof ChatMessageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageType = {
  Text: 'Text',
  Voice: 'Voice',
  Image: 'Image',
  Video: 'Video',
  Location: 'Location',
  System: 'System',
} as const;
